module.exports = __webpack_public_path__ + "images/cdba1f1264fb7f864462bc6513017376.svg";